var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isEditPromotion)?_c('v-btn',{staticStyle:{"top":"10px"},attrs:{"absolute":"","dark":"","fab":"","top":"","right":"","color":"primary"},on:{"click":function($event){_vm.promotionDialog = true}}},[_c('v-icon',{attrs:{"color":"black"}},[_vm._v("add")])],1):_vm._e(),_c('promotionForm',{attrs:{"selected_item":_vm.selected_item,"dialog":_vm.promotionDialog,"editedIndex":_vm.editedIndex},on:{"setDialog":function($event){_vm.promotionDialog = $event},"setEditIndex":function($event){_vm.editedIndex = $event}}}),_c('v-layout',{staticClass:"px-3",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":""}},[_c('v-text-field',{attrs:{"prepend-icon":"search","label":"Search code / name","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_c('v-spacer'),_c('v-flex',{attrs:{"xs12":"","sm3":""}},[_c('v-select',{attrs:{"items":[
          { name: 'All Service', value: -1 },
          { name: 'Food delivery', value: 1 },
          { name: 'Messenger', value: 2 },
        ],"item-text":"name","item-value":"value","single-line":"","hide-details":"","prepend-icon":"filter_alt"},model:{value:(_vm.filterOrderType),callback:function ($$v) {_vm.filterOrderType=$$v},expression:"filterOrderType"}})],1),_c('v-spacer')],1),_c('div',{staticClass:"py-1 mr-5",staticStyle:{"display":"flex","justify-content":"flex-end"}},[_c('download-excel',{staticStyle:{"margin-right":"50px"},attrs:{"data":_vm.filteredPromotionList,"fields":{
        'Order type': {
          field: 'promotion_order_type',
          callback: (value) => {
            return value == 1
              ? 'Food delivery'
              : value == 2
              ? 'Messenger'
              : value == 3
              ? 'Free'
              : '';
          },
        },
        Code: 'promotion_code',
        Name: 'promotion_name_th',
        Type: {
          field: 'promotion_type',
          callback: (value) => {
            if (value == 1) {
              return 'Product';
            } else if (value == 2) {
              return 'Transfer';
            } else if (value == 3) {
              return 'Product and transfer';
            }
            return '';
          },
        },
        Discount: 'promotion_discount',
        Unit: {
          field: 'promotion_unit',
          callback: (value) => {
            if (value == 1) {
              return '฿';
            } else if (value == 2) {
              return '%';
            }
            return '';
          },
        },
        Used: 'promotion_use',
        Total: 'promotion_amount',
        Start: 'promotion_start_date',
        End: 'promotion_end_date',
      },"name":'Promotion-list.xls'}},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',{attrs:{"large":"","color":"black"}},[_vm._v("print")]),_vm._v(".xls ")],1)],1),_c('download-excel',{attrs:{"type":"csv","data":_vm.filteredPromotionList,"fields":{
        'Order type': {
          field: 'promotion_order_type',
          callback: (value) => {
            return value == 1
              ? 'Food delivery'
              : value == 2
              ? 'Messenger'
              : value == 3
              ? 'Free'
              : '';
          },
        },
        Code: 'promotion_code',
        Name: 'promotion_name_th',
        Type: {
          field: 'promotion_type',
          callback: (value) => {
            if (value == 1) {
              return 'Product';
            } else if (value == 2) {
              return 'Transfer';
            } else if (value == 3) {
              return 'Product and transfer';
            }
            return '';
          },
        },
        Discount: 'promotion_discount',
        Unit: {
          field: 'promotion_unit',
          callback: (value) => {
            if (value == 1) {
              return '฿';
            } else if (value == 2) {
              return '%';
            }
            return '';
          },
        },
        Used: 'promotion_use',
        Total: 'promotion_amount',
        Start: 'promotion_start_date',
        End: 'promotion_end_date',
      },"name":'Promotion-list.csv'}},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',{attrs:{"large":"","color":"black"}},[_vm._v("print")]),_c('span',[_vm._v(".csv")])],1)],1)],1),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.filteredPromotionList,"pagination":_vm.pagination,"loading":_vm.loading_message,"rows-per-page-items":[25, 50, 100, 500, 1000, 2000]},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-center"},[_vm._v("\n        "+_vm._s(_vm.promotion_list.indexOf(props.item) + 1)+"\n      ")]),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(_vm.showOrderType(props.item)))]),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.promotion_code))]),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.promotion_name_th))]),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(_vm.filterPromoType(props.item)))]),_c('td',{staticClass:"text-xs-right"},[_vm._v("\n        "+_vm._s(props.item.promotion_discount + " " + _vm.filterPromoUnit(props.item))+"\n      ")]),_c('td',{staticClass:"text-xs-right"},[_vm._v("\n        "+_vm._s(props.item.promotion_use + " / " + props.item.promotion_amount)+"\n      ")]),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.promotion_start_date))]),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.promotion_end_date))]),_c('td',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","to":'/weserve_admin_login/control/' +
              _vm.$store.state.backOffice.province +
              '/food/' +
              props.item.promotion_id +
              '/promotionlog'},slot:"activator"},[_c('v-icon',{attrs:{"small":""}},[_vm._v("remove_red_eye")])],1),_c('span',[_vm._v("View log")])],1)],1),_c('td',{staticClass:"justify-center layout px-0"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},on:{"click":function($event){return _vm.editPromotion(props.item)}},slot:"activator"},[_c('v-icon',{attrs:{"small":""}},[_vm._v("edit")])],1),_c('span',[_vm._v("Edit")])],1),_c('v-tooltip',{attrs:{"top":""}},[(!_vm.isEditPromotion)?_c('v-btn',{attrs:{"slot":"activator","icon":""},on:{"click":function($event){return _vm.deletePromotion(props.item)}},slot:"activator"},[_c('v-icon',{attrs:{"small":""}},[_vm._v("delete")])],1):_vm._e(),_c('span',[_vm._v("Delete")])],1)],1)]}}])},[_c('template',{slot:"no-data"},[(_vm.loading_message == false)?_c('div',[_vm._v("No data available")]):_c('div',[_c('v-progress-circular',{attrs:{"size":30,"color":"primary","indeterminate":""}}),_vm._v("Loading data ...\n      ")],1)])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }